import styles from "./Footer.module.css"
import { Link } from "react-router-dom"
import AOS from "aos"
import "aos/dist/aos.css";

import whiteLogo from "../../images/whiteLogo.png"

import { useEffect, useState } from "react";


export default function Footer() {
    const [newYear, setNewYear] = useState()
    useEffect(() => {
        AOS.init({ duration: 2000 })
    }, [])
    const handleClick = () => {
        window.scrollTo(0, 0);
    };
    useEffect(() => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        console.log(currentYear);
        setNewYear(currentYear)
    }, [])
    return (
        <div className={styles.footerContainer}>
            {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 319"><path fill="#172B4D" fill-opacity="1" d="M0,64L80,80C160,96,320,128,480,122.7C640,117,800,75,960,64C1120,53,1280,75,1360,85.3L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg> */}
            <div className={styles.logoTitle}>
                <img className={styles.footerLogo} src={whiteLogo} />
                <h2>AHS Legal Services</h2>
            </div>
            <div className={styles.allNavi}>

                <Link onClick={handleClick} exact to="/" >
                    Home
                </Link>
                <Link onClick={handleClick} to="/about" >
                    About
                </Link>
                <Link onClick={handleClick} to="/services" >
                    Services
                </Link>
                <Link onClick={handleClick} to="/contact" >
                    Contact
                </Link>

            </div>

            <p className={styles.copyRight}>AHS Legal Services copyright &copy; {newYear} All rights reserved.</p>
            <p className={styles.creator}>
                Website designed and created by <a href="https://www.linkedin.com/in/shaikh-abdul-sami-879287211/">
                    <br /> Shaikh Abdul Sami</a>

            </p>

        </div>
    )
}





